import { apiClient } from "../client";
import type {
  FileUploadRequest,
  UpdateFileAttributesRequest,
  BulkUpdateAttributesRequest,
  BulkAddTagsRequest,
} from "./types";
import type {
  BulkOperationResult,
  FileUploadResponse,
} from "./fileUpload.types";

export async function completeFileUpload(
  fileId: string,
  data: FileUploadRequest
): Promise<void> {
  await apiClient.post(`files/${fileId}/complete`, { json: data });
}

export async function getFileContent(fileId: string): Promise<Blob> {
  const response = await apiClient.get(`files/${fileId}/content`, {});
  return response.blob();
}

export async function deleteFile(fileId: string): Promise<void> {
  await apiClient.delete(`files/${fileId}`, {});
}

export async function updateFileAttributes(
  fileId: string,
  data: UpdateFileAttributesRequest
): Promise<FileUploadResponse> {
  const response = await apiClient
    .put(`files/${fileId}/attributes`, { json: data })
    .json<FileUploadResponse>();

  return response;
}

export async function getFiles(): Promise<FileUploadResponse[]> {
  const response = await apiClient
    .get("files", {})
    .json<FileUploadResponse[]>();
  return response;
}

export async function trackFileView(fileId: string): Promise<void> {
  await apiClient.patch(`files/${fileId}/view`, {});
}

export async function bulkUpdateFileAttributes(
  data: BulkUpdateAttributesRequest
): Promise<BulkOperationResult<FileUploadResponse>> {
  const response = await apiClient
    .put("bulk/files/attributes", { json: data })
    .json<BulkOperationResult<FileUploadResponse>>();

  return response;
}

export async function bulkAddTagsToFiles(
  data: BulkAddTagsRequest
): Promise<BulkOperationResult<FileUploadResponse>> {
  const response = await apiClient
    .post("bulk/files/tags", { json: data })
    .json<BulkOperationResult<FileUploadResponse>>();

  return response;
}

export async function addTagToFile(
  fileId: string,
  tagId: number
): Promise<void> {
  await apiClient.post(`files/${fileId}/tags/${tagId}`);
}

export async function removeTagFromFile(
  fileId: string,
  tagId: number
): Promise<void> {
  await apiClient.delete(`files/${fileId}/tags/${tagId}`);
}
